export default "__VITE_ASSET__70c1b87b__"